import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import WithNavigation from './components/WithNavigation';
import ScrollToTop from './components/ScrollToTop';

import Components from './pages/Components';
import SignIn from './pages/SignIn';
import Authentication from './pages/Authentication';

import Calendar from './pages/calendar';
import Events from './pages/events';
import Birthdates from './pages/birthdates';
import Profile from './pages/profile';
import SearchDialog from './pages/SearchDialog';

import sitemaps from './configs/sitemaps';

import CreateEventDialog from './pages/CreateEventDialog';
import UpdateEventDialog from './pages/UpdateEventDialog';

import CreateTodoDialog from './pages/CreateTodoDialog';
import UpdateTodoDialog from './pages/UpdateTodoDialog';

import CreateBirthdateDialog from './pages/CreateBirthdateDialog';
import UpdateBirthdateDialog from './pages/UpdateBirthdateDialog';

import CreateSubmissionDialog from './pages/CreateSubmissionDialog';
import UpdateSubmissionDialog from './pages/UpdateSubmissionDialog';

import CreateProspectDialog from './pages/CreateProspectDialog';
import UpdateProspectDialog from './pages/UpdateProspectDialog';

import CreateTryDialog from './pages/CreateTryDialog';
import UpdateTryDialog from './pages/UpdateTryDialog';

function WithNavRoutes() {
	return (
		<WithNavigation>
			<Switch>
				{/* Landing page */}
				<Route path="/" exact>
					<Authentication />
				</Route>

				{/* Calendar */}
				<Route path={sitemaps.calendar.pathname}>
					<Calendar />
				</Route>

				{/* Events */}
				<Route path={sitemaps.events.pathname}>
					<Events />
				</Route>

				{/* Birthdates */}
				<Route path={sitemaps.birthdates.pathname}>
					<Birthdates />
				</Route>

				{/* Profile */}
				<Route path={sitemaps.profile.pathname}>
					<Profile />
				</Route>

				{/* Components */}
				<Route path="/components">
					<Components />
				</Route>
			</Switch>
		</WithNavigation>
	);
}

function Router() {
	return (
		<BrowserRouter>
			<ScrollToTop />
			<Switch>
				<Route path="/sign-in" exact>
					<SignIn />
				</Route>

				<Route path="/">
					<WithNavRoutes />
				</Route>

				{/* Error handling */}
				<Route>
					<div> 404 Not found</div>
				</Route>
			</Switch>

			<SearchDialog />

			<CreateEventDialog />
			<UpdateEventDialog />

			<CreateTodoDialog />
			<UpdateTodoDialog />

			<CreateBirthdateDialog />
			<UpdateBirthdateDialog />

			<CreateSubmissionDialog />
			<UpdateSubmissionDialog />

			<CreateProspectDialog />
			<UpdateProspectDialog />

			<CreateTryDialog />
			<UpdateTryDialog />			
		</BrowserRouter>
	);
}

export default Router;
